import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid";
import { observer } from "mobx-react";
import { CalendarEvent } from "../../models/Calendar";
import svLocale from "@fullcalendar/core/locales/sv";
import { Tooltip, Typography } from "@mui/material";

const Calendar = observer(({ events }: { events: CalendarEvent[] }) => {
  return (
    <FullCalendar
      plugins={[dayGridPlugin, timeGridPlugin]}
      initialView="dayGridMonth"
      events={events}
      height={"84vh"}
      firstDay={1}
      locale={svLocale}
      headerToolbar={{
        left: "prev,next today",
        center: "title",
        right: "timeGridDay,timeGridWeek,dayGridMonth",
      }}
      eventContent={(arg) => {
        return (
          <Tooltip
            title={arg.event.title}
            placement="top"
            enterTouchDelay={0}
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "offset",
                    options: { offset: [0, -10] },
                  },
                ],
              },
            }}
          >
            <Typography
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {arg.event.title}
            </Typography>
          </Tooltip>
        );
      }}
    />
  );
});

export default Calendar;
